<div class="main-container">
  <!-- Header Section -->
  <div class="page-header">
    <div class="routing-buttons">
      <div
        class="action-button back-button"
        (click)="navigateBack()"
        tabindex="0"
        (keydown.enter)="navigateBack()"
      >
        <mat-icon class="icon back-icon">arrow_back</mat-icon>
      </div>
      <div
        class="action-button reload-button"
        (click)="ngOnInit()"
        tabindex="0"
        (keydown.enter)="ngOnInit()"
      >
        <mat-icon class="icon reload-icon">refresh</mat-icon>
      </div>
      <span class="page-title">Device System Activity Log</span>
    </div>
    <div class="button-group">
      <app-system-activity-log-info></app-system-activity-log-info>
    </div>
  </div>

  <div class="component-container">
    <div class="component-header">
      <h6 class="component-title">Device System Activity Log</h6>
      <div class="component-actions">
        <button
          class="primary-button"
          (click)="downloadDeviceSystemActivityLog()"
          [disabled]="Responses.length === 0 || isDownloading"
          type="button"
        >
          Download Report
          <mat-icon class="btn-icon">download</mat-icon>
        </button>
        <app-common-component-dropdown-search
          [items]="filterList"
          [initialValue]="form?.get('filter')?.value"
          [placeHolder]="'Select Activity Type'"
          (itemSelected)="onFilter($event)"
        ></app-common-component-dropdown-search>
        <app-common-search
          [initialSearchValue]="form?.get('search')?.value"
          matTooltip="IMEI"
          (searchSubmit)="onSearch($event)"
        ></app-common-search>
      </div>
    </div>
    <!-- Separator between Header and Body -->
    <div class="component-separator"></div>
    <div class="component-body">
      <table>
        <thead>
          <tr>
            <th>IMEI</th>
            <th>Activity Type</th>
            <th>Activity Performed</th>
            <th>Packet</th>
            <th class="sticky-col-right">Activity Performed At</th>
          </tr>
        </thead>
        @if (totalLength !== 0) {
          <tbody>
            @for (
              response of Responses
                | paginate
                  : {
                      id: 'paginate',
                      itemsPerPage: size,
                      currentPage: page,
                      totalItems: totalLength,
                    };
              track response;
              let i = $index
            ) {
              @for (act of response.activities; track act; let j = $index) {
                <tr>
                  @if (j === 0) {
                    <td [attr.rowspan]="response.activities.length">
                      {{ response.imei }}
                    </td>
                  }
                  <td>{{ act.activityType }}</td>
                  <td>{{ act.serverResponse || '--' }}</td>
                  @if (j === 0) {
                    <td [attr.rowspan]="response.activities.length">
                      {{ response.loginPacket }}
                    </td>
                    <td
                      class="sticky-col-right"
                      [attr.rowspan]="response.activities.length"
                    >
                      {{
                        response.createdAt | date: 'dd MMM yyyy | hh:mm:ss a'
                      }}
                    </td>
                  }
                </tr>
              }
            }
          </tbody>
        }
        @if (totalLength === 0) {
          <tbody>
            <tr>
              <td colspan="12">
                <img
                  class="no-data-img"
                  src="../../assets/dataNotFound.jpg"
                  alt="No Data Found"
                  tabindex="0"
                />
              </td>
            </tr>
          </tbody>
        }
      </table>
    </div>
    <!-- Separator between Header and Body -->
    <div class="component-separator"></div>
    <!-- Component Footer Section -->
    <div class="component-footer">
      @if (totalLength !== 0) {
        <app-common-component-pagination
          [totalItems]="totalLength"
          [pageSize]="size"
          [currentPage]="page"
          (pageChange)="onPageChange($event)"
          (sizeChange)="onSizeChange($event)"
        >
        </app-common-component-pagination>
      }
    </div>
  </div>
</div>
